import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loadable from '@/components/common/loadable';
import { getCategoryDetail } from '@/store/actions/category';
import Loading from '@/components/common/loading';

const CategoryDetailComponent = Loadable({
  loader: () => import('@/components/category/detail'),
});

export default ({ match }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(({ category }) => category.isLoading);

  useEffect(() => {
    dispatch(getCategoryDetail({ ...match.params }));
  }, []);
  if (isLoading) return <Loading isLoading />;
  return <CategoryDetailComponent id={match.params.id} />;
};
